import React, { ReactElement } from "react"
import PostBaseCard from "./PostBaseCard";

export interface BlogCardProps {
    title: string,
    body: string,
    duration: string,
    date: string,
    type?: string,
    image?: string,
    tag: string,
    linkTo?: string,
    className?: string,
}

const BlogCard: React.FC<BlogCardProps> = ({ title, body, duration, date, type='Blog', image, tag,
    linkTo='#', className }): ReactElement => (
    <PostBaseCard title={title} body={body} duration={duration} date={date} type={type} tag={tag}
        linkTo={linkTo} className={className}>
        <img src={image} loading="lazy"
                className='object-cover max-w-none min-w-full min-h-full'
        />
    </PostBaseCard>
);

export default BlogCard;
